import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { endpoint: String }

  connect() {
    const form = this.element.closest("form")
    if (!form) return console.error("Cannot find a <form> container for SMS.")
    const phone = form.querySelector('input[name*="phone"]')
    if (!phone)
      return console.error("Cannot find a phone <input> element for SMS.")

    this.phone = phone
    this.phoneDiv = this.phone.parentElement
    this.phoneErrorContainer = this.phoneDiv.nextElementSibling
    this.formMessage = document.getElementById("form_message")
  }

  disconnect() {
    this.#hidePhoneError()
  }

  async send(event) {
    if (this.buttonTarget.disabled)
      return console.log("验证码发送倒计时尚未结束")
    if (!this.phone.value.match(/^1[3-9]\d{9}$/))
      return this.#showPhoneError("手机号格式不正确")

    try {
      const response = await fetch(this.endpointValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
            .content,
        },
        body: JSON.stringify({ phone: this.phone.value }),
      })

      if (response.ok) {
        const html = await response.text()

        this.#startCountdown(html)
        this.#hidePhoneError()
      } else {
        const data = await response.json()
        this.#showPhoneError(data.error || "发送失败，请重试")
      }
    } catch (error) {
      console.error("发送短信验证码失败:", error)
      this.#showPhoneError("发送失败，请重试")
    }
  }

  #startCountdown(successMessage = null) {
    const button = this.buttonTarget

    let seconds = 60
    button.disabled = true

    const interval = setInterval(() => {
      seconds--
      button.textContent = `${seconds}s后重新发送`
      button.classList.add("text-[#99A1B7]")
      if (successMessage) {
        Turbo.renderStreamMessage(successMessage)
        successMessage = null
      }

      if (seconds <= 0) {
        clearInterval(interval)
        button.disabled = false
        button.textContent = "发送验证码"
        button.classList.remove("text-[#99A1B7]")
        if (this.formMessage) this.formMessage.innerHTML = ""
      }
    }, 1000)
  }

  #showPhoneError(message) {
    this.phoneDiv.ariaInvalid = true
    this.phoneErrorContainer.textContent = message
  }

  #hidePhoneError() {
    this.phoneDiv.ariaInvalid = false
    this.phoneErrorContainer.textContent = ""
  }
}
